module.exports = __webpack_public_path__ + "static/media/menuSliderBackground.939a11bd.svg";